import { ChipContainer, PlainTooltip } from "@similarweb/ui-components";

import { keywordGroupsQueryClient, keywordGroupsKeys } from "app/services/keyword-groups";
import type { IUserKeywordGroup } from "app/services/keyword-groups/keywordGroups.types";
import { AutocompleteKeywordGroups } from "pro-features/components/AutocompleteKeywords/AutocompleteKeywordsGroups";
import { i18nFilter } from "app/filters/i18nFilter";
import {
    ChipContainerWrapper,
    Title,
} from "app/pages/website-analysis/traffic-sources/search/components/filters/styledComponents";
import { FlexRow } from "app/pages/website-analysis/website-content/leading-folders/components/Tab";
import queryClient from "single-spa/react-app/query-client";
import { StyledTitleIcon } from "pro-features/styled components/Workspace/src/StyledWorkspaceBox";

export const getChipsForBoolean = (
    array: any[],
    state: string,
    setState,
    OnRemoveItem: (item, state, setState) => void,
    isGroup = false,
    iconName?,
) => {
    const result = array.map((item) => {
        const textToDisplay = isGroup
            ? queryClient.getQueryData<IUserKeywordGroup | null>(keywordGroupsKeys.byId(item))?.Name || item
            : item;
        return {
            text: textToDisplay,
            iconName: iconName,
            key: `${item}CHIP`,
            onCloseItem: OnRemoveItem(item, state, setState),
        };
    });
    return result;
};

export const renderChips = (array, state, setState, OnRemoveItem, itemsComponent, iconName?, isGroup = false) => {
    return (
        <ChipContainerWrapper>
            <ChipContainer itemsComponent={itemsComponent}>
                {getChipsForBoolean(array, state, setState, OnRemoveItem, isGroup, iconName)}
            </ChipContainer>
        </ChipContainerWrapper>
    );
};

export const titleAndTooltip = (tooltipContent: string, title: string) => {
    return (
        <FlexRow>
            <Title>{i18nFilter()(title)}</Title>
            <PlainTooltip tooltipContent={i18nFilter()(tooltipContent)}>
                <div>
                    <StyledTitleIcon
                        iconName="info"
                        size="xs"
                    />
                </div>
            </PlainTooltip>
        </FlexRow>
    );
};

const renderAutocomplete = (
    isInclude: boolean,
    onAutocompleteFocus: (isInclude) => void,
    handleAdd: (isGroupContext, id, isInclude) => void,
    overrideEnterFunc,
    keywordsToFilterFromAutocomplete,
    keywordsGroupsToFilterFromAutocomplete,
) => {
    const placeholder = isInclude
        ? "competitors.search.ranking.distribution.boolean.keywords.filter.input"
        : "competitors.search.ranking.distribution.boolean.keywords.filter.exclude.input";
    return (
        <AutocompleteKeywordGroups
            autocompleteProps={{
                placeholder: i18nFilter()(placeholder),
                searchIcon: "keywords",
                zIndex: isInclude ? 10 : 0,
                autoTruncateResultsOnCloseClick: true,
                onFocus: () => onAutocompleteFocus(isInclude),
            }}
            onClick={async (keywordsObj: any) => {
                const groupContext = await keywordGroupsQueryClient.getGroupById(keywordsObj.Id);
                const isGroupContext = groupContext && Object.keys(groupContext).length > 0;
                handleAdd(isGroupContext, isGroupContext ? keywordsObj.Id : keywordsObj.name, isInclude);
            }}
            overrideEnterFunc={overrideEnterFunc(isInclude)}
            clearTextValueOmItemSelect={true}
            showEditButton={false}
            showShareButton={false}
            keywordsToFilterFromAutocomplete={keywordsToFilterFromAutocomplete}
            keywordsGroupsToFilterFromAutocomplete={keywordsGroupsToFilterFromAutocomplete}
        />
    );
};
